module.exports = __webpack_public_path__ + "img/20200409143950864.557bcfe1.png";